export default __webpack_public_path__ + "images/49ea90c736dfc12e1a17a604a7218260.png";